import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthContextService } from '@core/services/auth-context.service';
import { AuthService } from '@core/services/auth.service';

@Component({
  selector: 'app-callback-signout',
  standalone: true,
  template: '',
})
export class CallbackSignoutComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly ctx = inject(AuthContextService);
  private readonly auth = inject(AuthService);

  async ngOnInit(): Promise<void> {
    this.auth.setAuthenticated(false);

    const mode = this.ctx.getMode();
    await this.router.navigateByUrl(
      mode === 'upload-files' ? '/upload-files' : '/login',
    );
  }
}
